<script>
    import {mapState, mapActions, mapGetters} from 'vuex'


    export default {
        props: {
            label: String,
            name: {
                type: [String, Array, Number]
            },
            value: {
                type: [String, Array, Number]
            },
            paymentOperation: {
                type: [String, Number]
            },
            contragentType: {
                type: [String, Number]
            },
            contragent: {
                type: [String, Number]
            },
            contragentName: {
                type: [String, Number]
            },
            legal: {
                type: [String, Number]
            },
            currency: {
                type: [String, Number]
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            payment: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                val: this.value,
                lab: this.name,
                modal: false
            }
        },
        methods: {
            change(v) {
                if (!this.multiple) {
                    this.val = v.value;
                    this.lab = v.label;
                    this.$emit('input', v.value);
                    this.$emit('update:label', v.label);
                    this.$emit('change', v);
                } else {
                    this.$emit('add', v);
                    if (Array.isArray(this.val)) {
                        v.forEach(i => {
                            let bool = true;
                            this.val.forEach(j => {
                                if (i.value === j.value) bool = false;
                            });
                            if (bool) this.val.push(i);
                        });
                    } else {
                        this.val = [];
                        v.forEach(i => {
                            let bool = true;
                            this.val.forEach(j => {
                                if (i.value === j.value) bool = false;
                            });
                            if (bool) this.val.push(i);
                        });
                    }
                    this.$emit('input', this.val);
                    this.$emit('change', this.val);
                }
            },
            click() {
                this.$dialog('regular_search', {
                    change: this.change,
                    multiple: !!this.multiple,
                    typePayment: !!this.payment,
                    list: this.val,
                    paymentOperation: this.paymentOperation,
                    contragentType: this.contragentType,
                    contragent: this.contragent,
                    legal: this.legal,
                    currency: this.currency,
                    contragentName: this.contragentName,
                });
            },
            handleClose(item) {
                console.log(this.val.indexOf(item));
                this.val.splice(this.val.indexOf(item), 1);
                this.$emit('input', this.val);
                this.$emit('change', this.val);
                this.$emit('remove', item);
            }
        },
        computed: {},
        watch: {
            value(v) {
                this.val = v;
            },
            name(v) {
                this.lab = v;
            },
        },
        components: {},
        mounted() {
        },
        destroyed() {
        },
    }
</script>
<template>
    <div class="input-regular">
        <el-input :value="lab" disabled v-if="!multiple">
            <template v-if="label" slot="prepend">{{label}}</template>
            <el-button slot="append" icon="el-icon-search" title="Найти" @click="click"></el-button>
        </el-input>
        <div v-if="multiple" class="el-input-group el-input--mini el-input-group--prepend el-input-group--append">
            <div class="el-input-group__prepend">{{label}}</div>
            <span class="el-input__inner">
                <el-tag v-if="val" v-for="item in val" :key="item.value" closable :disable-transitions="false" @close="handleClose(item)">{{item.label}}</el-tag>
            </span>
            <div class="el-input-group__append">
                <el-button slot="append" icon="el-icon-search" title="Найти" @click="click"></el-button>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    .input-regular {
        position: relative;
        .el-input__inner {
            display: inline-table;
        }
        .el-input.is-disabled .el-input__inner {
            background: #fff;
            cursor: default;
            color: #333;
        }
        .el-tag {
            margin: 2px 4px;
            height: auto;
            white-space: normal;
        }
    }
</style>
